import { Col, Row } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FieldBuilder from "../../form-components/field-builder";
import EndPoints from "../../../services/end-points";
import { IUser } from "../../../models/user/response";

interface IProps {}

const SendNotificationMessage: React.FC<IProps> = () => {
  const { t } = useTranslation();

  return (
    <>
      <Row gutter={[16, 8]}>
        <Col span={24}>
          <FieldBuilder
              name="message"
              label={t("message")}
              input={{type: "text-area"}}
              rules={{required: true}}
          />
        </Col>
      </Row>
    </>
  );
};

export default SendNotificationMessage;
